import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { ActivityLogPage } from 'features/history/pages/ActivityLogPage'
import { BuildsPage } from 'features/history/pages/BuildsPage'
import { HistoryPageTab } from './types'

export const useTabs = (): Tab<HistoryPageTab>[] => {
  const { t } = useTranslation('features/history', { keyPrefix: 'tabs' })

  return [
    {
      element: 'builds',
      label: t('builds'),
      page: <BuildsPage />,
    },
    {
      element: 'activity-log',
      label: t('activityLog'),
      page: <ActivityLogPage />,
    },
  ]
}
